import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PlaylistService } from 'src/app/Core/services/playlist.service';
import { UtilService } from 'src/app/Core/services/util.service';

@Component({
  selector: 'app-create-playlist-profile',
  templateUrl: './create-playlist-profile.component.html',
  styleUrls: ['./create-playlist-profile.component.css']
})
export class CreatePlaylistProfileComponent implements OnInit{

  profile:any = {
    playlist_id:'',
    profile_name:'',
    profile_image:'',
    pin:'',
    parental_pin:''
  }
  title:any;
  profilePic:any;
  defaultPic ='/assets/images/new_login_flow/add-profile.png';
  categories:any;


  constructor(private router:Router,private playlistService:PlaylistService,private utilService:UtilService,private route:ActivatedRoute) {
      this.route.queryParams.subscribe(res =>{
        this.profile.playlist_id = res.id
        
      })
  }

  ngOnInit(): void {
      this.getProfileCategory()
  }

  getProfileCategory(){
    this.playlistService.getProfileCategories().subscribe(((res:any)=>{
      this.categories = res.categories;
      console.log(this.categories);
    }))
  }

  onSubmit(payload:NgForm){
    // if(userForm.valid){}
    let passModel: any = {
     playlist_id:this.profile.playlist_id,
     profile_name:this.profile.profile_name,
     pin:this.profile.pin,
     parental_pin:this.profile.parental_pin,
     profile_image:this.defaultPic
    };   
    if(payload.valid){
      console.log(payload,'===',passModel);
      this.playlistService.createProfile(passModel).subscribe((res:any)=>{
        console.log(res);
        if(res){
          this.router.navigate(['/profile'],{state:{id:passModel.playlist_id}})
        }
      },(error)=>{
        console.log(error);
        
      })
    }
  }

  selectedProfilePic(item){
    console.log(item);
    this.profilePic = item.imageUrl;
    if(this.profilePic){
      this.defaultPic = this.profilePic
    }
  }

  back(){
    this.router.navigate(['/profile'],{state:{id:this.profile.playlist_id}})
  }

}
